<template>
  <div class="diamond">
    <div class="spotOrderList_head">
      <div class="orderNumber">
        <span class="orderClass" v-if="pieceData.orderSource === '1'">智慧商城订单</span>
        <span class="orderClass" v-else>云展厅订单</span>
      </div>
      <div class="orderNumber">
        <span>订单编号：</span>
        <span v-text="pieceData.orderNo"></span>
      </div>
      <div class="orderDate"><span>下单时间：</span><span v-text="pieceData.createdTime"></span></div>
      <div class="upDownTopClass" @dblclick="seccendCopy(pieceData.netAddress)">
        <el-tooltip class="item" effect="dark" :content="pieceData.netAddress" placement="top-start">
          <el-button>
            <div class="dotName"><span class="dotNameTitle">网点名称：</span><span v-text="pieceData.netAddress" class="dotNameText"></span></div>
          </el-button>
        </el-tooltip>
      </div>
      <div class="network">
        <span>网点编码：</span>
        <span v-text="pieceData.netCode"></span>
      </div>
    </div>
    <div class="spotOrderList">
      <div>
        <div class="spotOrderList_body_data">
          <div class="spotOrderList_body_data_father" v-for="(val, i) in pieceData.detailList" :key="i" v-if="i < 3 || !pieceData.showNone">
            <div class="spotOrderList_body_childTwo">
              <div class="goods">
                <div class="spotOrderList_body_img">
                  <img @click="enlargeImg(val)" :src="val.imgPath" alt="" />
                </div>
                <div class="orderStyleType">
                  <div class="bigClassName">{{ val.productName }}</div>
                  <div class="styleNumber-text">款号：{{ val.styleNumber }}</div>
                  <div class="spotBtn" v-if="pieceData.isSpot === '1' && pieceData.isPresell !== '1'">现货钻石</div>
                  <div class="spotBtn" v-if="pieceData.isSpot === '0' && pieceData.isPresell !== '1'">定单钻石</div>
                  <div class="spotBtn" v-if="pieceData.isPresell === '1'">预售定单</div>
                </div>
              </div>
              <div class="listChild orderSpecifications">
                <div class="specifications">
                  <div>
                    材质：<span>{{ val.texture }}</span>
                  </div>
                  <div>
                    品类：<span>{{ pieceData.productCategoryName }}</span>
                  </div>
                  <div>
                    规格：<span>{{ val.ringSize }}</span>
                  </div>
                  <div>
                    GIA：<span>{{ val.gia | cutFilter }}</span>
                  </div>
                  <div>
                    戒壁封石：<span>{{ val.seal }}</span>
                  </div>
                  <div>
                    主石：<span>{{ val.mainStone }}</span>
                  </div>
                  <!-- <div>
                    主石重量：<span>{{ val.mainStoneSize }}</span>
                  </div> -->
                </div>
                <div class="specifications">
                  <div>
                    切工：<span>{{ val.cut }}</span>
                  </div>
                  <div>
                    荧光：<span>{{ val.fluorescence }}</span>
                  </div>
                  <div>
                    金重：<span>{{ val.goldWeigh }}</span>
                  </div>
                  <div>
                    净度：<span>{{ val.mainStoneClarity }}</span>
                  </div>
                  <div>
                    色度：<span>{{ val.mainStoneColour }}</span>
                  </div>
                  <div>
                    辅石名称：<span>{{ val.gemName }}</span>
                  </div>
                  <div>
                    版型：<span>{{ val.formatType }}</span>
                  </div>
                </div>
              </div>
              <div class="orderLabel">
                <div v-if="val.labelPrice">标签金额：{{ val.labelPrice }}</div>
                <div v-if="hasPriceViewPermission()">
                  结算金额：{{ val.tradePrice }}
                </div>
                <div v-if="val.exclusivePrice && !val.labelPrice">尊享价：{{ val.exclusivePrice }}</div>
              </div>
              <div class="ordrerNumberChild">{{ pieceData.isSpot === '1' ? val.size : val.quantity }}</div>
              <div class="diamondRemarkClass">
                <el-tooltip class="item" effect="dark" :content="val.productRemark" placement="bottom">
                  <el-button>
                    <div class="spotOrderList_body_child_mainStone">
                      {{ val.productRemark }}
                    </div>
                  </el-button>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex; align-items: center; position: absolute; left: 837px; top: 0; bottom: 0; height: 100%">
        <div class="spotOrderList_Tail orderReamrk">
          <div style="display: flex; align-items: center">
            <el-tooltip class="item" effect="dark" :content="pieceData.remark" placement="top">
              <el-button>
                <div style="display: flex"><span style="display: block"></span><span v-text="pieceData.remark" class="totalRemark"></span></div>
              </el-button>
            </el-tooltip>
          </div>
        </div>
        <div class="orderAmount">
          <div>总件数：{{ pieceData.totalQuantity }}</div>
          <div>标签总金额：{{ pieceData.totalLabelAmount }}</div>
          <div v-if="hasPriceViewPermission()">
            结算总金额：{{ pieceData.totalTradeAmount }}
          </div>
        </div>
        <div class="ordrerNumber">{{ pieceData.pendingQuantity }}</div>
        <div class="orderType">{{ pieceData.groupStatus | orderPresellTypeFilter }}</div>
        <div class="updata">
          <div class="updataBtn" @click="getExpress('view')" v-if="pieceData.groupStatus == '6' || pieceData.groupStatus == '7'">查看物流</div>
          <div class="updataBtn" @click="getExpress('cancel')" v-if="pieceData.groupStatus == '0'">取消</div>
          <div class="updataBtn" @click="getExpress('verify')" v-if="pieceData.groupStatus == '6'">确认收货</div>
        </div>
      </div>
    </div>
    <div class="toViewMore" v-if="pieceData.detailList.length > 3" @click="showHidden">
      共有&nbsp;<span style="color: #ec9368">{{ pieceData.detailList.length }}</span
      >&nbsp;种商品,<span v-if="pieceData.showNone">还有&nbsp;{{ pieceData.detailList.length - 3 }}&nbsp;种,</span
      ><span v-if="pieceData.showNone">点击查看</span><span v-if="!pieceData.showNone">点击收起</span>
    </div>
    <DiamondSpot
      v-if="diamondSpotDialogVisible"
      :diamondSpotDialogVisible="diamondSpotDialogVisible"
      @onCloseSelectDialog="onCloseSelectDialog"
      :modifyingReplication="modifyingReplication"
    />
  </div>
</template>

<script>
import DiamondSpot from './spot/DiamondSpot.vue';
import { orderPresellTypeFilter, cutFilter } from '@/utils/filetrs';
export default {
  name: 'Diamond',
  props: {
    pieceData: {
      type: Object,
      default() {
        return {};
      },
    },
    index: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  components: {
    DiamondSpot,
  },
  filters: {
    orderPresellTypeFilter,
    cutFilter,
  },
  data() {
    return {
      diamondSpotDialogVisible: false,
      modifyingReplication: {},
    };
  },
  mounted() {},
  methods: {
    // 获取物流
    getExpress(type) {
      this.$emit('fetchExpress', type, this.pieceData.orderNo);
    },
    // 订单跳转详情页
    enlargeImg(res) {
      if (this.pieceData.orderSource !== '1') {
        this.$router.push({
          path: '/diamondDetails',
          query: {
            id: res.productId,
            styleNumber: res.styleNumber,
            generaName: res.productName,
            eliminate: res.eliminate,
            styleFlag: this.pieceData.isSpot === '1' ? '钻石现货' : '钻石定单',
            codeType: res.columnCode,
            classify: res.classify,
            groupFlag: this.pieceData.detailList[0].groupFlag ? this.pieceData.detailList[0].groupFlag : null,
          },
        });
      }
    },
    // 关闭弹窗
    onCloseSelectDialog() {
      this.diamondSpotDialogVisible = false;
    },
    // 获取现货列表
    getSpot(val) {
      this.modifyingReplication = val;
      this.diamondSpotDialogVisible = true;
    },
    // 展示隐藏大于3条的数据
    showHidden() {
      this.$emit('showHidden', this.index);
    },
    // 复制网点名称
    seccendCopy(netAddress) {
      var that = this;
      this.$copyText(netAddress).then(function (e) {
        that.$message({
          message: '复制成功!',
          type: 'success',
          duration: 1500,
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.diamond {
  .spotOrderList_head {
    display: flex;
    background: #fff2ea;
    line-height: 40px;
    border: 1px solid rgb(237, 226, 206);
    border-bottom: none;
    align-items: center;
    box-sizing: border-box;
    width: 1500px;

    .orderNumber {
      margin-left: 10px;
      .orderClass {
        padding: 4px;
        background: #ec9368;
        color: #ffffff;
        font-size: 12px;
        border-radius: 4px;
      }
    }

    .orderDate {
      margin: 0 18px 0 10px;
    }

    .network {
      margin-right: 18px;
    }

    .upDownTopClass {
      margin-right: 18px;

      .dotName {
        display: flex;
        font-family: -webkit-body;

        .dotNameTitle {
          display: block;
        }

        .dotNameText {
          text-align: left;
          width: 400px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .el-button {
        width: 600px;
        background: #fff2ea;
        border: none;
        font-size: 16px;
        padding: 0;
        text-align: left;
        color: #000;
        height: 40px;
        line-height: 40px;
      }
    }
  }

  .spotOrderList_body_img {
    margin-left: 10px;
    margin-top: 20px;

    img {
      width: 70px;
      height: 70px;
      cursor: pointer;
      box-sizing: border-box;
      border: 1px solid rgb(220, 223, 230);
    }
  }

  .spotOrderList_body_childTwo {
    display: flex;
    border-right: 1px solid rgb(220, 223, 230);
    border-bottom: 1px solid rgb(220, 223, 230);
  }

  .spotOrderList_body_data_father:last-child .spotOrderList_body_childTwo {
    border-bottom: none;
  }

  .spotOrderList {
    display: flex;
    align-items: center;
    border: 1px solid rgb(237, 226, 206);
    width: 1498px;
    position: relative;
  }

  .spotOrderList_body_data {
    min-height: 110px;
    border-bottom: 1px solid rgb(237, 226, 206);
    position: relative;
  }

  .spotOrderList_body_data:last-child {
    border-bottom: none;
  }

  .spotOrderList_body_data_father {
    margin-left: 6px;
    font-size: 14px;
  }

  .goods {
    display: flex;
    border-right: 1px solid #ede2ce;
    box-sizing: border-box;
    padding: 15px 0;
    width: 225px;
    margin-right: 5px;
  }

  .orderStyleType {
    margin-left: 10px;
    margin-top: 20px;
  }

  .spotBtn {
    width: 100px;
    margin-top: 10px;
    text-align: center;
    height: 32px;
    line-height: 32px;
    color: #ec9368;
    font-size: 14px;
    border: 1px solid #ec9368;
    border-radius: 5px;
    cursor: pointer;
  }

  .bigClassName:hover {
    color: red;
  }

  .bigClassName {
    width: 120px;
    white-space: pre-wrap;
  }

  .orderSpecifications {
    width: 265px;
    padding-right: 30px;
    border-right: 1px solid #ede2ce;
    box-sizing: border-box;
    padding: 15px 0;
    margin-right: 5px;
  }

  .orderLabel {
    width: 145px;
    padding: 15px 0;
    margin-right: 5px;
    border-right: 1px solid #ede2ce;
    box-sizing: border-box;
    white-space: normal;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .ordrerNumber {
    width: 75px;
    padding: 15px 0;
    margin-right: 5px;
    border-right: 1px solid #ede2ce;
    box-sizing: border-box;
    white-space: normal;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 5px;
  }
  .ordrerNumberChild {
    width: 75px;
    padding: 15px 0;
    margin-right: 5px;
    border-right: 1px solid #ede2ce;
    box-sizing: border-box;
    white-space: normal;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .orderReamrk {
    width: 100px;
  }

  .totalRemark {
    width: 100px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #999999;
    text-align: center;
  }

  .goodsRemark {
    width: 150px;
  }

  .orderAmount {
    width: 205px;
    border-left: 1px solid #ede2ce;
    border-right: 1px solid #ede2ce;
    padding-left: 5px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    div {
      margin: 10px 0;
    }
  }

  .orderType {
    width: 100px;
    padding-left: 5px;
    height: 100%;
    border-right: 1px solid #ede2ce;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    white-space: break-spaces;
  }
  .updata {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100px;
    padding-left: 5px;
    height: 183px;
    .updataBtn {
      padding: 6px 14px;
      color: #ec9368;
      margin: 10px;
      text-align: center;
      font-size: 14px;
      border-radius: 10px;
      cursor: pointer;
    }
  }
  .diamondRemarkClass {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .el-button {
      background: #fff;
      border: none;
      font-size: 16px;
      padding: 0;
      text-align: center;
      color: #000;
      width: 100px;
      height: 34px;
      line-height: 34px;
    }
  }

  .spotOrderList_Tail .el-button {
    width: 100px;
    background: transparent;
    border: none;
    font-size: 16px;
    padding: 0;
    text-align: left;
    color: #000 !important;
    font-family: -webkit-body;
  }

  .spotOrderList_body_child_mainStone {
    min-width: 90px;
    color: #ec9368;
    margin-top: 2px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: left;
  }

  .toViewMore {
    text-align: center;
    cursor: pointer;
    height: 40px;
    line-height: 40px;
    border: 1px solid rgb(237, 226, 206);
    border-top: none;
  }
}
</style>
